import { Bulletins } from "../../types/Bulletins/Bulletins";
import { PaginationValues } from "../../types/General/PaginationValues";
import api from "../../utils/api";
import { BULLETIN_URL } from "../../utils/endpoints";

export async function getBulletins(
  id?: string,
  filterValues?: any,
  paginationValues?: PaginationValues,
) {
  try {
    const response = await api.get(
      id ? `${BULLETIN_URL}/${id}` : `${BULLETIN_URL}`,
      {
        params: {
          ...filterValues,
          ...paginationValues,
        },
      },
    );

    const data = id
      ? response.data
      : response.data.result.map((option: Bulletins) => ({
          id: option.id,
          name: option.name,
          month: option.month,
          year: option.year,
          type: option.type,
          province: option.province ?? null,
          county: option.county ?? null,
          updatedAt: option.updatedAt,
          createdAt: option.createdAt,
        }));

    return { content: data, totalItems: response.data.totalItems };
  } catch (error) {
    throw error;
  }
}
